export const ANALYTICS_PRODUCT_NAME = 'Forecast';

/**
 * Module names for analytics (usage data) in CS reporting
 *
 * These are detected via:
 *  - the <UsageTracker> React component
 *  - react-router matchPath rules defined in client/components/Navigation/views.ts
 */
export enum ANALYTICS_MODULE_NAMES {
  OVERVIEW = 'Overview',
  WELL_DETAILS = 'Well Details',
  ACTIVITY_MODEL = 'Activity Model',
  PROJECT_MODIFIERS = 'Project Modifiers',
  COST_SETUP = 'Cost Setup',
  RESULTS = 'Results',
  TIME_TRACKER = 'Time Tracker',
  COST_TRACKER = 'Cost Tracker',
  ESTIMATES = 'Estimates',
  COMPARISONS = 'Comparisons',
  CAMPAIGNS = 'Campaigns',
  AUTOMATION_RULESETS = 'Automation Rulesets',
  OTHER = 'Other',
}

/**
 * Feature names for analytics (usage data) in CS reporting
 *
 * These are specified by CS department when they want to track a particular feature of interest, and "wired up" by
 * Devs to specific buttons in the UI
 */
export enum ANALYTICS_FEATURE_NAMES {}

export enum ANALYTICS_TRACKING_TYPES {
  PAGE_VIEW = 'Page View',
  FEATURE_CLICKED = 'Feature Clicked',
}

export enum ANALYTICS_EVENT_TYPES {
  CLICK = 'click',
}

export enum ANALYTICS_ENGINES {
  MIXPANEL = 'mixpanel',
}
